import React from 'react';
import { useLocation } from 'react-router-dom';
import { IconButton, Typography } from '@mui/material';
import { Menu } from 'lucide-react';
import styled from 'styled-components';
import Logo from '../../assets/images/AIMS_Logo_white_TM.png';
import { COLORS } from '../../Styles/Colors';
import { MOBILE_TOPBAR_HEIGHT } from '../../Styles/AppStyles';

const Bar = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: calc(${MOBILE_TOPBAR_HEIGHT}px + env(safe-area-inset-top, 0px));
  background: ${COLORS.darkGray};
  color: ${COLORS.white};
  display: flex;
  align-items: center;
  gap: 4px;
  padding: env(safe-area-inset-top, 0px) 12px 0 4px;
  z-index: 1100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
`;

const Brand = styled.img`
  height: 28px;
  width: auto;
  flex-shrink: 0;
`;

function formatSegment(segment: string): string {
  return segment
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

function titleFromPath(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length === 0) return 'Home';
  const last = segments[segments.length - 1];
  if (/^\d+$/.test(last) && segments.length > 1) {
    return formatSegment(segments[segments.length - 2]);
  }
  return formatSegment(last);
}

interface MobileTopBarProps {
  onMenuClick: () => void;
}

const MobileTopBar: React.FC<MobileTopBarProps> = ({ onMenuClick }) => {
  const { pathname } = useLocation();
  const title = titleFromPath(pathname);

  return (
    <Bar>
      <IconButton
        aria-label="Open navigation"
        onClick={onMenuClick}
        sx={{ color: COLORS.white, width: 44, height: 44 }}
      >
        <Menu size={22} />
      </IconButton>
      <Brand src={Logo} alt="AIMS" />
      <Typography
        variant="subtitle1"
        noWrap
        sx={{
          ml: 1,
          fontWeight: 600,
          fontSize: '0.95rem',
          minWidth: 0,
          flex: 1,
        }}
      >
        {title}
      </Typography>
    </Bar>
  );
};

export default MobileTopBar;
